<template>
  <footer>
    <div class="nav-box">
      <router-link to="/map">
        Garden Map
      </router-link>
    </div>
    <div class="nav-box">
      <router-link to="/allstops">
        All Stops
      </router-link>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'BottomNav',
  components: { }
}
</script>
<style lang="scss" scoped>
  footer {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
    justify-content: space-around;
    background-color: #FFFFFF;
    font-size: 0.7rem;
  }

  footer > div.nav-box {
    flex: 1;
  }

  footer > div.nav-box a {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;

    background-color: #e2e2e2;
    color: #000000;

    min-width: 60px;
    height: 60px;
    border: 1px solid #FFFFFF;
    padding: 5px;

    font-weight: bold;
    text-decoration: none;
  }

  footer > div.nav-box a.router-link-exact-active,
  footer > div.nav-box a.router-link-active {
    background-color: #000000;
    color: #FFFFFF;
  }
</style>
